import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import GenericCard from "components/UI/GenericCard/GenericCard";

const ConversationsList = ({
  conversations,
  selectedConversationId,
  onSelectConversation,
  onNewConversation,
}) => {
  return (
    <GenericCard className="flex flex-col h-full rounded-lg w-64">
      <div className="flex flex-col overflow-y-auto h-full">
        <Button
          type="default"
          icon={<PlusOutlined />}
          onClick={onNewConversation}
          className="w-full h-12 rounded-lg mb-2"
        >
          New Conversation
        </Button>

        {/* Conversations List */}
        <div className="flex-1 overflow-y-auto py-2 h-full">
          {conversations.map((conversation) => (
            <Button
              key={conversation._id}
              type={
                selectedConversationId === conversation._id ? "primary" : "text"
              }
              onClick={() => onSelectConversation(conversation._id)}
              className={`w-full h-auto min-h-[50px] flex items-center px-2 mb-2 justify-start rounded-lg`}
            >
              <span className="truncate">{conversation.title}</span>
            </Button>
          ))}

          {conversations.length === 0 && (
            <div className="text-center py-12 text-[rgba(255,255,255,0.6)]">
              <div className="text-3xl mb-3 opacity-50">💬</div>
              <p className="text-sm font-medium">No conversations yet</p>
              <p className="text-xs opacity-70 mt-1">
                Start a new chat to begin
              </p>
            </div>
          )}
        </div>
      </div>
    </GenericCard>
  );
};

export default ConversationsList;
